import * as cx from 'classnames'
import * as React from 'react'

import { IItemCard } from '../interface'

import ui from '../../../../common/constants/ui'
import EnhancedLazyLoad from '../../../components/enhancedLazyLoad'
import TrendingSash from '../../../components/trendingSash'
import ItemCardAudioContent from '../itemCardAudioContent'
import ItemCardSmallSidebar from '../itemCardSmallSidebar'

import * as styles from './audioJungleItemCard.module.css'

interface IState {
  collapsed: boolean
}

class AudioJungleItemCard extends React.Component<IItemCard, IState> {
  public render() {
    const { item, rank, onItemLinkClick, viewType } = this.props

    const rootClass = cx(styles.root, {
      [styles.listView]: viewType === 'list',
      [styles.gridView]: viewType !== 'list'
    })

    return (
      <li className={rootClass}>
        <article className={styles.card}>
          {item.trending && (
            <EnhancedLazyLoad height="100%" once offset={ui.lazyLoadOffset}>
              <TrendingSash />
            </EnhancedLazyLoad>
          )}
          <ItemCardAudioContent {...this.props} />
          <div className={styles.sidebar}>
            <ItemCardSmallSidebar {...this.props} />
          </div>
        </article>
      </li>
    )
  }
}

export default AudioJungleItemCard
